<template>
  <div class="alliance">
    <!-- 主视觉区域 -->
    <section class="hero">
      <!-- <div class="container">
        <div class="hero-content">
          <h1>江泰国际合作联盟</h1>
          <p>全球风险、全球发布、全球商机、全球服务</p>
        </div>
      </div> -->
    </section>

    <!-- 联盟介绍区域 -->
    <section class="alliance-intro">
      <div class="container">
        <h2 class="section-title">联盟介绍</h2>
        <div class="intro-content">
          <p>顺应中国企业走出去本地化风险管理服务的需要，2013年1月17日，江泰保险经纪股份有限公司发起成立江泰国际合作联盟。联盟总部设在中国北京，是目前全球唯一一家由中国保险经纪人主导，以为中国走出去企业提供世界一流的本地化服务为基本目标的全球服务网络。</p>
        </div>
      </div>
    </section>

    <!-- 联盟成员分布区域 -->
    <section class="alliance-distribution">
        <h2 class="section-title">联盟成员分布</h2>
        <div class="distribution-content">
          <div class="distribution-image">
            <img src="@/assets/images/alliance/position.png" alt="联盟成员分布图">
          </div>
        </div>
    </section>

    <!-- 部分联盟成员区域 -->
    <section class="alliance-members">
      <div class="container">
        <h2 class="section-title">部分联盟成员</h2>
        <div class="members-grid">
          <div class="members-grid-image">
            <img src="@/assets/images/alliance/part-pc.png" alt="联盟成员">
          </div>
        </div>
      </div>
    </section>

    <!-- 联系信息区域 -->
    <section class="contact-info">
      <div class="container">
        <div class="contact-card">
          <p>国际保险相关事宜，请第一时间联系： 
            
            <br/>
            姓名：王维成David Wang
            <br/>
            电话： +86 10 6980 8888
            <br/>
            邮箱：<a href="mailto:wangweicheng.re@jiangtai.com" style="text-decoration: underline">wangweicheng.re@jiangtai.com</a>
           
            </p>
          <a class="btn-primary"  href="mailto:wangweicheng.re@jiangtai.com">邮件联系</a>
        </div>
      </div>
    </section>

    <!-- 优投网区域 -->
    <section class="utou-platform">
      <div class="container">
        <div class="utou-content">
          <div class="utou-logo">
            <img src="@/assets/images/alliance/youtou-logo.png" alt="优投网">
          </div>
          <div class="utou-text">
            <h2>优投网</h2>
            <p>整合全球资源，帮助中国企业走得出，走得稳！</p>
            <p>优投网针对中国企业“走出去”面临的“缺信息、缺资源、缺人才、缺人脉、缺风险管理、缺全球救援”的现状，聚焦对外投资服务和境外安全风险防控服务，双轮驱动助力中国企业跨境发展。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 平台资源网络区域 -->
    <section class="platform-resources">
      <div class="container">
        <h2 class="section-title">平台资源网络</h2>
        <div class="resources-grid">
          <div class="resource-item">
            <h3>境外网点</h3>
            <div class="resource-number">1546家</div>
            <p>遍布全球主要国家和地区，为中国企业提供本地化风险管理服务</p>
          </div>
          <div class="resource-item">
            <h3>境外服务商</h3>
            <div class="resource-number">1234家</div>
            <p>包括律师事务所、会计师事务所、咨询公司等专业服务机构</p>
          </div>
          <div class="resource-item">
            <h3>社会资源</h3>
            <div class="resource-number">907家</div>
            <p>包括政府机构、行业协会、研究机构等社会资源</p>
          </div>
          <div class="resource-item">
            <h3>商务资源</h3>
            <div class="resource-number">23家</div>
            <p>包括银行、投资机构、贸易公司等商务资源</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 平台服务区域 -->
    <section class="platform-services">
      <div class="container">
        <h2 class="section-title">平台服务</h2>
        <div class="services-grid">
          <div class="service-item">
            <div class="service-icon">
              <img src="@/assets/images/alliance/tab1.png" alt="一揽子服务">
            </div>
            <h3>一揽子服务</h3>
            <p>提供全方位的风险管理解决方案</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <img src="@/assets/images/alliance/tab2.png" alt="专家咨询服务">
            </div>
            <h3>专家咨询服务</h3>
            <p>提供专业的风险管理咨询服务</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <img src="@/assets/images/alliance/tab3.png" alt="国际化服务">
            </div>
            <h3>国际化服务</h3>
            <p>提供全球化的风险管理服务</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <img src="@/assets/images/alliance/tab4.png" alt="在线咨询服务">
            </div>
            <h3>在线咨询服务</h3>
            <p>提供便捷的在线咨询服务</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <img src="@/assets/images/alliance/tab5.png" alt="安全保障服务">
            </div>
            <h3>安全保障服务</h3>
            <p>提供全面的安全保障服务</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <img src="@/assets/images/alliance/tab6.png" alt="十二大服务">
            </div>
            <h3>十二大服务</h3>
            <p>提供十二大类专业服务</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 优投网介绍区域 -->
    <section class="utou-intro">
      <div class="container">
        <h2 class="section-title">优投网</h2>
        <div class="utou-intro-content">
          <div class="utou-image">
            <img src="@/assets/images/alliance/youtou-html.png" alt="优投网截图">
          </div>
          <div class="utou-description">
            <p>平台整合了外国驻华招商机构、境外园区、境外专业投资服务机构等资源，并精心打造了优投36500会员服务，提供对外投资全球服务资源、对外投资知识库、热门投资资讯、全球安全动态、全球救援综合服务、境外安全风险服务、对外投资咨询服务等服务;围绕企业“走出去”落地的关键环节提供优投会员产品，包括境外园区入驻、境外机构注册、境外投资风险报告等。本着有投必帮之初心，优投网为企业搭建全球资源线上对接渠道，促进企业开展各类投资活动，切实解决企业“走出去”面临的难题。</p>
            <button class="btn-primary" @click="gotoUtou">访问官网</button>
          </div>
        </div>
      </div>
    </section>
    <loginOrRegister ref="loginOrRegister"></loginOrRegister>

  </div>
</template>

<script>
import loginOrRegister from '@/components/loginOrRegister.vue'
export default {
  name: 'Alliance',
  components: {
    loginOrRegister
  },
  methods: {
    gotoUtou() {
      window.open('https://www.iutou.cn/', '_blank');
    },
    showLoginModal() {
      this.$refs.loginOrRegister.showLoginModal('register')
    }
  }
}
</script>

<style scoped>
.alliance {
  width: 100%;
}

/* 主视觉区域样式 */
.hero {
  width: 100%;
  background-size: cover;
  background-position: center;
  height: 500px;
  display: flex;
  align-items: center;
  color: #fff;
  position: relative;
  overflow: hidden;
  /* margin-top: -80px; */
   /* 调整与导航栏的距离 */
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/alliance/banner.png');
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  text-align: center;
  margin: 0 auto;
}

.hero h1 {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.hero p {
  font-size: 1.8rem;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* 通用部分样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  padding-bottom: 1rem;
  color: #333;
  font-weight: 600;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background-color: #0052D9;
}

section {
  padding: 80px 0;
}

.btn-primary {
  background-color: #0052D9;
  color: white;
  border: none;
  padding: 14px 32px;
  font-size: 1.1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 82, 217, 0.2);
}

.btn-primary:hover {
  background-color: #003EB3;
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 82, 217, 0.3);
}

/* 联盟介绍区域样式 */
.alliance-intro {
  background-color: #f9f9f9;
}

.intro-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.intro-content p {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #555;
}

/* 联盟成员分布区域样式 */
.alliance-distribution {
  background-color: #fff;
}

.distribution-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.distribution-image {
  width: 100%;
  margin-bottom: 40px;
  overflow: hidden;
}
.distribution-image img {
  width: 100%;
  display: block;
}


.distribution-text {
  text-align: center;
  margin-bottom: 50px;
}

.distribution-text h3 {
  font-size: 2.2rem;
  color: #0052D9;
  margin-bottom: 20px;
  font-weight: 600;
}

.distribution-text p {
  font-size: 1.3rem;
  color: #555;
}

.distribution-values {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 25px;
  margin-top: 40px;
}

.value-item {
  background-color: #f0f5ff;
  padding: 16px 35px;
  border-radius: 30px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 82, 217, 0.1);
}

.value-item:hover {
  background-color: #e0ebff;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 82, 217, 0.15);
}

.value-item span {
  font-size: 1.2rem;
  font-weight: 500;
  color: #0052D9;
}

/* 联盟成员区域样式 */
.alliance-members {
  background-color: #f9f9f9;
}

.members-grid {
  /* display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px; */
  /* background-image: url('@/assets/images/alliance/banner.png'); */

  
}
.members-grid-image {
  width: 100%;
  margin-bottom: 40px;
  overflow: hidden;
}

.members-grid-image img {
  width: 100%;
  display: block;
}

.member-item {
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.member-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
}

.member-item img {
  width: 80%;
  max-height: 150px;
  object-fit: contain;
}

/* 联系信息区域样式 */
.contact-info {
  background-color: #fff;
}

.contact-card {
  background: linear-gradient(135deg, #073A90, #073A90);
  color: #fff;
  padding: 50px;
  border-radius: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  box-shadow: 0 15px 30px rgba(0, 82, 217, 0.2);
}

.contact-card p {
  font-size: 1.3rem;
  margin-bottom: 25px;
  max-width: 800px;
}

.contact-card .btn-primary {
  background-color: #fff;
  color: #0052D9;
  font-weight: 600;
  padding: 15px 40px;
}

.contact-card .btn-primary:hover {
  background-color: #f0f0f0;
}

/* 优投网区域样式 */
/* .utou-platform {
  background: linear-gradient(135deg, #FF6B00, #FF9500);
  color: #fff;
} */
.utou-platform  {
  width: 100%;
  background-size: cover;
  background-position: center;
  height: 400px;
  display: flex;
  align-items: center;
  color: #fff;
  /* position: relative; */
  overflow: hidden;
  background-image: url('@/assets/images/alliance/youtou-banner.png');

}

.utou-content {
  display: flex;
  align-items: center;
  gap: 50px;
}

.utou-logo {
  flex: 0 0 180px;
}

.utou-logo img {
  width: 100%;
  background-color: #fff;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.utou-text {
  flex: 1;
}

.utou-text h2 {
  font-size: 2.8rem;
  margin-bottom: 25px;
  font-weight: 600;
}

.utou-text p {
  font-size: 1.2rem;
  margin-bottom: 15px;
  line-height: 1.6;
}

/* 平台资源网络区域样式 */
.platform-resources {
  background-color: #f9f9f9;
}

.resources-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 35px;
}

.resource-item {
  background-color: #fff;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.3s ease;
}

.resource-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
}

.resource-item h3 {
  color: #0052D9;
  margin-bottom: 20px;
  font-size: 1.4rem;
  font-weight: 600;
}

.resource-number {
  font-size: 3rem;
  font-weight: bold;
  color: #0052D9;
  margin-bottom: 20px;
}

.resource-item p {
  font-size: 1rem;
  color: #666;
  line-height: 1.5;
}

/* 平台服务区域样式 */
.platform-services {
  /* background-color: #fff; */
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 25px;
}

.service-item {
  text-align: center;
  transition: all 0.3s ease;
  padding: 20px 15px;
  border-radius: 8px;
  background-color: #fff;

}

.service-item:hover {
  background-color: #f0f5ff;
  transform: translateY(-5px);
}

.service-icon {
  margin-bottom: 20px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-icon img {
  width: 60px;
  height: 60px;
  transition: transform 0.3s ease;
}

.service-item:hover .service-icon img {
  transform: scale(1.1);
}

.service-item h3 {
  font-size: 1.1rem;
  color: #333333;
  margin-bottom: 12px;
  font-weight: 600;
}

.service-item p {
  font-size: 0.95rem;
  color: #333333;
}

/* 优投网介绍区域样式 */
.utou-intro {
  background-color: #f9f9f9;
}

.utou-intro-content {
  display: flex;
  align-items: center;
  gap: 50px;
}

.utou-image {
  flex: 0.5;
}

.utou-image img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.utou-description {
  flex: 1;
}

.utou-description p {
  font-size: 1.2rem;
  margin-bottom: 35px;
  line-height: 1.7;
  color: #555;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    max-width: 960px;
  }
  
  .services-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
  
  .service-item {
    margin-bottom: 20px;
  }
}

@media (max-width: 992px) {
  .container {
    max-width: 720px;
  }
  
  .hero {
    height: 400px;
  }
  
  .resources-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .members-grid {
    /* grid-template-columns: repeat(2, 1fr); */
  }
  
  .utou-content, .utou-intro-content {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  
  .utou-logo {
    margin: 0 auto;
    flex: 0 0 120px;

  }
  
  .services-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 968px) {
  .utou-content {
    display: flex;
    align-items: center;
    gap: 0px;
  }
  .utou-text h2 {
    font-size: 2.2rem;
  }
  
  .utou-text p {
    font-size: 1.1rem;
  }
}
@media (max-width: 768px) {
  .container {
    max-width: 540px;
  }
  
  .hero {
    height: 550px;
    /* background-image: url('@/assets/images/alliance/banner-h5.jpg'); */
  }
  .hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('@/assets/images/alliance/banner-h5.png');
    background-size: cover;
    background-position: center;
    z-index: 1;
  }
  .hero h1 {
    font-size: 2.5rem;
  }
  
  .hero p {
    font-size: 1.3rem;
  }
  
  .section-title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  
  section {
    padding: 60px 0;
  }
  
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .distribution-text h3 {
    font-size: 1.8rem;
  }
  
  .distribution-text p {
    font-size: 1.1rem;
  }
  
  .contact-card {
    padding: 30px 20px;
  }
  
  .contact-card p {
    font-size: 1.1rem;
  }
  
  .utou-text h2 {
    font-size: 2.2rem;
  }
  
  .utou-text p {
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .hero {
    height: 380px;
    background-image: url('@/assets/images/alliance/banner-h5.png');

    /* margin-top: -50px; */
  }
  
  .hero h1 {
    font-size: 2rem;
  }
  
  .hero p {
    font-size: 1.1rem;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .members-grid, .resources-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  
  .distribution-values {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .resource-number {
    font-size: 2.5rem;
  }
  
  .resource-item {
    padding: 30px 20px;
  }
  
  .contact-card p {
    font-size: 1rem;
  }
  
  .utou-logo {
    flex: 0 0 120px;
  }
  
  .service-icon img {
    width: 50px;
    height: 50px;
  }
  
  .service-item h3 {
    font-size: 1rem;
  }
  
  .service-item p {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
  
  .hero {
    height: 380px;
  }
  
  .hero h1 {
    font-size: 1.8rem;
  }
  
  .hero p {
    font-size: 1rem;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  section {
    padding: 50px 0;
  }
  
  .intro-content p {
    font-size: 1rem;
  }
  
  .distribution-text h3 {
    font-size: 1.5rem;
  }
  
  .distribution-text p {
    font-size: 1rem;
  }
  
  .value-item {
    padding: 12px 25px;
  }
  
  .value-item span {
    font-size: 1rem;
  }
  
  .btn-primary {
    padding: 12px 25px;
    font-size: 1rem;
  }
}
</style> 